<template>
    <el-upload action="/file/upload" :data="{dir:dir}" :file-list="fileList"
	:on-change="onChange" :on-remove="onChange" :on-preview="preview" :key="updateKey">
        <el-button size="mini" type="primary" plain>upload</el-button>
    </el-upload>
</template>

<script>
export default {
	data(){
		return {
			fileList:[],
			updateKey: 0,
		}
	},
	props:{
		value:{},
		dir:{type:String,required:true},
	},
	watch:{
		value(newV,oldV){
			if(newV){
				const v = JSON.parse(newV);
				if(this.fileList.length===0){
					if(Array.isArray(v)){
						this.fileList = v.map(row=>{return {
							name:row.file_name,
							response:row
						}})
					}else{
						this.fileList = [{name:v.file_name,response:v}]
					}
				}
				setTimeout(() => {
					this.updateKey++;
				}, 0);
			}
		}
	},
	methods:{
		onChange(files,fileList){
			this.fileList = fileList;
			this.$emit('input',JSON.stringify(this.fileList.map(row=>row.response)));
		},
		onRemove(file, fileList) {
			this.fileList = fileList;
			const nowList = this.fileList.map(row=>row.response);
			let jsonRes = null;
			if (nowList.length) {
				jsonRes = JSON.stringify(nowList);
			}
			this.$emit('input',jsonRes);
		},
		preview(file){
			console.log(file);
			window.open(`/preview?file=${file.response.file_path}`)
		}
	}
}
</script>

